module.exports = __webpack_public_path__ + "static/media/no-data-img.eafe25eb.png";